import React from 'react'
import TopBar from '../components/TopBar'
import Nav from '../components/Nav'
import Footer from '../components/Footer'

function Actus() {
  return (
    <div>
      <TopBar />
      <Nav />

      <Footer />
    </div>
  )
}

export default Actus